export default __webpack_public_path__ + "static/media/cert-customer-hkgcsmeaa.fb6c62b0.jpg";